exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".heatmap-wrapper {\n  text-align: center;\n  margin-top: 10px;\n  margin-bottom: 0px; }\n  .heatmap-wrapper .ant-select {\n    margin-bottom: 20px;\n    width: 200px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/modules/AnalyticsMetric/components/Visualizations/HeatmapChart/style.scss
// module id = 999
// module chunks = 0